<template>
  <div id="summary" class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="close"><span class="blind">close</span></button>
      <h1 class="toCapitalize notranslate">{{locale.message_reservation_summary}}</h1>
      <h2 class="room">{{summary.spaceName[lang]}}</h2>
      <div class="submitAt notranslate">{{submitAt}}</div>
      <div class="summaryItem">
        <div class="optionInfo">
          <div class="row notranslate">
            <span class="label toCapitalize">{{locale.reservation_use_date}}</span>
            <div class="value">{{summary.date}}</div>
          </div>
          <div class="row notranslate">
            <span class="label toCapitalize">{{locale.reservation_use_time}}</span>
            <div class="value">
              {{summary.time.label && summary.time.label[lang].length > 0 ? `${summary.time.label[lang]} - ${summary.time.name}` : summary.time.name}}
            </div>
          </div>
          <div class="row notranslate">
            <span class="label toCapitalize">{{locale.reservation_use_person}}</span>
            <div class="value">{{summary.person}}</div>
          </div>
          <div class="row">
            <span class="label toCapitalize notranslate">{{locale.reservation_use_section}}/{{locale.reservation_use_place}}</span>
            <div v-if="!summary.autoAssign" class="value">
              <div v-for="(seat, index) in seats"
                :key="index">
                {{seat.section.name[lang]}}
                <span v-if="summary.showPlaceName || summary.showSeatName">
                  -
                  <span v-if="summary.showPlaceName">{{seat.place.name[lang]}}</span>
                  <span v-if="summary.showPlaceName && summary.showSeatName"> / </span>
                  <span v-if="summary.showSeatName">{{seat.seat.name[lang]}}</span>
                </span>
              </div>
            </div>
            <div v-else-if="seats && seats.section" class="value">
              {{ seats.section.name[lang] }} / {{ seats.place.name[lang] }}
            </div>
            <div v-else>-</div>
          </div>
          <div v-if="summary.firstName" class="row notranslate">
            <span class="label toCapitalize">{{locale.reservation_book_first_name}}</span>
            <div class="value">{{summary.firstName}}</div>
          </div>
          <div v-if="summary.lastName" class="row notranslate">
            <span class="label toCapitalize">{{locale.reservation_book_last_name}}</span>
            <div class="value">{{summary.lastName}}</div>
          </div>
          <div v-if="summary.phone" class="row notranslate">
            <span class="label toCapitalize">{{locale.reservation_book_phone}}</span>
            <div class="value">{{summary.phone}}</div>
          </div>
          <div v-if="summary.email" class="row notranslate">
            <span class="label toCapitalize">{{locale.reservation_book_email}}</span>
            <div class="value">{{summary.email}}</div>
          </div>
          <div
            v-for="item in summaryAdditionalInfo || []"
            :key="item.id"
            class="row">
            <span class="label">
              {{ item.label && item.label[lang] }}
            </span>
            <div class="value">
              {{ getAdditionalInfoValue(item) }}
            </div>
          </div>
        </div>
      </div>
      <div class="btns notranslate">
        <button type="button" class="btn btnWhite toCapitalize" @click.stop="close">{{locale.cancel}}</button>
        <button
          type="button"
          class="btn toCapitalize"
          @click.stop="confirm">{{locale.do_reservation}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import moment from 'moment/moment'

export default {
  name: 'Summary',
  props: [
    'lang',
    'locale',
    'summary'
  ],
  components: {
  },
  computed: {
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    submitAt: {
      get () {
        const submitAt = DateTime.fromISO(this.summary.submitAt || moment().toISOString(), { zone: this.timezone })
        return submitAt.toFormat(this.format)
      },
      set (sa) {
        // console.log(sa)
      }
    },
    seats () {
      return this.summary.autoAssign ? this.summary.seats[0] : this.summary.seats
    },
    summaryAdditionalInfo () {
      return this.summary.additionalInfo || []
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('confirm')
    },
    getAdditionalInfoValue (item) {
      if (item.type === 'input') {
        return item.value || '-'
      }

      if (Array.isArray(item.value)) {
        const values = item.value
          .map(x => x.label && x.label[this.lang])
          .filter(Boolean)

        return values.length > 0
          ? values.join(', ')
          : '-'
      }

      return '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  font-size: 14px;
  z-index: 9999999;
  .inner {
    align-items: initial !important;
    justify-content: initial !important;
  }
}
.room {
  margin-top: 0.5em;
  margin-bottom: 2px;
  padding-bottom: 0.2em;
  text-align: center;
  font-size: 1.6em;
  font-weight: 700;
  border-bottom: 4px solid $color-dark;
}
.submitAt {
  margin-bottom: 1.2em;
  padding-top: 0.2em;
  font-size: 0.85em;
  color: $color-grey;
  border-top: 1px solid $color-dark;
  input {
    width: 100%;
    padding: 0;
    border: none;
    background: none;
  }
}
.optionInfo {
  border-top: 1px solid $color-lgrey;
  border-bottom: 1px solid $color-lgrey;
  .row {
    display: flex;
    align-items: center;
    padding-top: 0.75em;
    padding-bottom: 0.75em;
    &:nth-of-type(2n) {
      background-color: $bg-default;
    }
  }
  .label {
    width: 100px;
    padding-right: 1em;
    font-weight: bold;
  }
  .value {
    flex: 1;
  }
}
</style>
